import LogRecordT, {
  LogRecordType,
} from '../../../../../bridge/utils/LogRecord';
import moment from 'moment';
import './index.css';
import { useState } from 'react';
import { BiSolidDownArrow, BiSolidUpArrow } from 'react-icons/bi';

const lineColors = ['yellow', 'orange', 'red', 'yellow'];

const getShouldLevelDown = (value: any) =>
  (typeof value !== 'undefined' || value !== null) &&
  typeof value === 'object' &&
  ((Array.isArray(value) && value.length > 0) ||
    (!!value && Object.keys(value).length > 0));

const shouldDefaultCollapse = (value: any) => {
  const str = JSON.stringify(value);
  return str.length > 500;
};

const LogRecord = ({ logRecord }: { logRecord: LogRecordT }) => {
  const date = moment(logRecord.timestamp).format('DD MMM yy hh:mm:ss');

  return (
    <li className="logRecord">
      <p className="logRecord-date">{date}</p>
      <Value logRecord={logRecord} />
    </li>
  );
};

const Key = ({
  keyValue,
  value,
  renderValue,
  iteration,
}: {
  keyValue: string;
  value: any;
  iteration: number;
  renderValue: (value: any, iteration?: number) => any;
}) => {
  const [isCollapsed, setIsCollapsed] = useState(shouldDefaultCollapse(value));

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: getShouldLevelDown(value)
          ? isCollapsed
            ? 'row'
            : 'column'
          : 'row',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: shouldDefaultCollapse(value) ? 'pointer' : 'default',
        }}
        onClick={() => setIsCollapsed((prev) => !prev)}
      >
        <div
          style={{
            width: iteration * 15,
            height: 1,
            backgroundColor: lineColors[iteration - 1],
            opacity: 0.8 - iteration * 0.2,
          }}
        ></div>
        <span
          style={{
            color: '#AFAFAF',
            margin: 0,
            padding: 0,
            paddingLeft: !iteration ? 0 : 5,
          }}
        >
          {keyValue}:
        </span>
        {shouldDefaultCollapse(value) ? (
          Array.isArray(value) ? (
            <span style={{ color: 'white', paddingLeft: 5 }}>
              [
              {isCollapsed ? (
                <BiSolidDownArrow color="white" size={10} />
              ) : (
                <BiSolidUpArrow color="white" size={10} />
              )}
              ]
            </span>
          ) : typeof value === 'object' ? (
            <span style={{ color: 'white', paddingLeft: 5 }}>
              {'{'}
              {isCollapsed ? (
                <BiSolidDownArrow color="white" size={10} />
              ) : (
                <BiSolidUpArrow color="white" size={10} />
              )}
              {'}'}
            </span>
          ) : null
        ) : null}
      </div>
      {isCollapsed ? null : renderValue(value, iteration + 1)}
    </div>
  );
};

const Value = ({ logRecord }: { logRecord: LogRecordT }) => {
  const type = logRecord.type;
  const messageClassName =
    type === LogRecordType.Info
      ? 'logRecord-info'
      : type === LogRecordType.Error
      ? 'logRecord-error'
      : 'logRecord-object';

  if (type !== LogRecordType.Variable) {
    return <p className={messageClassName}>{logRecord.message}</p>;
  }

  const renderValue = (value: any, iteration = 0): any => {
    if (typeof value === 'undefined' || value === null) {
      return null;
    }

    if (typeof value !== 'object') {
      return (
        <span
          key={`${value}`}
          style={{
            color: 'white',
            margin: 0,
            padding: 0,
            paddingLeft: 7,
            fontWeight: 'bold',
          }}
        >
          {`${value}`}
        </span>
      );
    }

    if (Array.isArray(value) && value.length === 0) {
      return (
        <span
          key={`${value}`}
          style={{
            color: 'white',
            margin: 0,
            padding: 0,
            paddingLeft: 10,
          }}
        >
          {'[]'}
        </span>
      );
    }

    const amountOfKeys = Object.keys(value).length;
    if (amountOfKeys === 0) {
      return (
        <span
          key={`${value}`}
          style={{
            color: 'white',
            margin: 0,
            padding: 0,
            paddingLeft: 10,
          }}
        >
          {'{}'}
        </span>
      );
    }

    return Object.entries(value).map(([key, value], index) => (
      <Key
        key={`${index}_${key}`}
        keyValue={key}
        value={value}
        renderValue={renderValue}
        iteration={iteration}
      />
    ));
  };

  return renderValue(logRecord.message);
};

export default LogRecord;
